import axios, { AxiosRequestConfig } from "axios";
import NativeClient from "@/client/native-client";
import store from "@/store";
import { AxiosError } from "axios";

/** API実行時のサーバエラーが想定外の形式の場合に設定するデフォルトのエラー定義 */
const defaultApiError = {
  title: "ネットワークに接続できません",
  type: null,
  error: {
    message:
      "ネットワークに接続できません。スマートフォンがインターネットに接続できないようです。ネットワークの設定をご確認ください。",
    code: null
  }
};

/** File Download クライアント */
const requestFridgeFileFunc = async (config: AxiosRequestConfig) => {
  try {
    NativeClient.sendDebugLog("requestFridgeFileFunc getApiParams completed");
    NativeClient.sendDebugLog("requestFridgeFileFunc config = " + JSON.stringify(config));
    NativeClient.sendDebugLog("requestFridgeFileFunc token exist");
    return {
      ...config,
      headers: {
        ...config.headers,
        "content-type": "application/json;charset=UTF-8",
      }
    };
  } catch (error) {
    NativeClient.sendDebugLog("requestFridgeFileFunc catch");
    NativeClient.sendDebugLog("requestFridgeFileFunc catch error = " + error);
    NativeClient.sendDebugLog("requestFridgeFileFunc catch error config = " + JSON.stringify(config));
    return config;
  }
};
  
  /** API実行エラー時の共通処理 */
const responseFridgeFileErrorFunc = (error: AxiosError) => {
  const { response } = error;
  const { request } = error;
  const { code } = error;
  
  // エラー発生時は、loadingを止める
  store.dispatch("common/stopLoading");
  store.dispatch("common/stopFullscreenLoading");

  // エラー時処理
  if (response && response.status > 0 && response.data) {
    // サーバエラーが想定内のフォーマットの場合
    if (!NativeClient.setAPIErrorState(response.status, response.data)) {
      store.dispatch("common/updatedApiError", response.data);
    }
    NativeClient.sendDebugLog("responseFridgeFileErrorFunc response code = " + response.status + ", body = " + JSON.stringify(response.data));
  } else {
    // デフォルトのエラー設定
    store.dispatch("common/updatedApiError", defaultApiError);
  }
  NativeClient.sendDebugLog("responseFridgeFileErrorFunc code = " + JSON.stringify(code));
  NativeClient.sendDebugLog("responseFridgeFileErrorFunc request = " + JSON.stringify(request));
  NativeClient.sendDebugLog("responseFridgeFileErrorFunc response = " + JSON.stringify(response));
  return Promise.reject(error);
};

/** API クライアント */
export const fridgeFileDownloadClient = axios.create({
  baseURL: process.env.VUE_APP_FRIDGE_FILE_BASE_URL,
  headers: {
    'Content-Type': 'application/json; charset=UTF-8',
    Accept: "application/json",
  },
  responseType: 'json'
});

/** 共通リクエスト */
fridgeFileDownloadClient.interceptors.request.use(requestFridgeFileFunc);

/** 共通エラーケース */
fridgeFileDownloadClient.interceptors.response.use(response => response, responseFridgeFileErrorFunc);